import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_vue2editor_2de2f454 from 'nuxt_plugin_vue2editor_2de2f454' // Source: ./vue2-editor.js (mode: 'client')
import nuxt_plugin_apollomodule_806daa4c from 'nuxt_plugin_apollomodule_806daa4c' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_pluginutils_7801c226 from 'nuxt_plugin_pluginutils_7801c226' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_76b3a4f8 from 'nuxt_plugin_pluginrouting_76b3a4f8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_0d282977 from 'nuxt_plugin_pluginmain_0d282977' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_9921de94 from 'nuxt_plugin_cookieuniversalnuxt_9921de94' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_27654d0e from 'nuxt_plugin_axios_27654d0e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_buefy_2d776742 from 'nuxt_plugin_buefy_2d776742' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_googleanalytics_34921350 from 'nuxt_plugin_googleanalytics_34921350' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_aws_5e4623c7 from 'nuxt_plugin_aws_5e4623c7' // Source: ../../../plugins/aws (mode: 'client')
import nuxt_plugin_i18ncompare_aa7992a8 from 'nuxt_plugin_i18ncompare_aa7992a8' // Source: ../../../plugins/i18n-compare (mode: 'client')
import nuxt_plugin_cleave_2450328d from 'nuxt_plugin_cleave_2450328d' // Source: ../../../plugins/cleave.js (mode: 'client')
import nuxt_plugin_vue2filters_577e82e7 from 'nuxt_plugin_vue2filters_577e82e7' // Source: ../../../plugins/vue2-filters.js (mode: 'client')
import nuxt_plugin_vuecountryregionselect_5048da16 from 'nuxt_plugin_vuecountryregionselect_5048da16' // Source: ../../../plugins/vue-country-region-select.js (mode: 'client')
import nuxt_plugin_materialdesignicons_b188790a from 'nuxt_plugin_materialdesignicons_b188790a' // Source: ../../../plugins/material-design-icons (mode: 'client')
import nuxt_plugin_json5_346d62d2 from 'nuxt_plugin_json5_346d62d2' // Source: ../../../plugins/json5 (mode: 'client')
import nuxt_plugin_timeago_cf036a34 from 'nuxt_plugin_timeago_cf036a34' // Source: ../../../plugins/timeago (mode: 'client')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../../../plugins/filters (mode: 'client')
import nuxt_plugin_veevalidatei18n_1c3a79c8 from 'nuxt_plugin_veevalidatei18n_1c3a79c8' // Source: ../../../plugins/vee-validate-i18n (mode: 'client')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../../../plugins/vee-validate (mode: 'client')
import nuxt_plugin_mixins_5013a1f0 from 'nuxt_plugin_mixins_5013a1f0' // Source: ../../../plugins/mixins (mode: 'client')
import nuxt_plugin_i18ncookie_bb2b8886 from 'nuxt_plugin_i18ncookie_bb2b8886' // Source: ../../../plugins/i18n-cookie (mode: 'client')
import nuxt_plugin_vueyoutube_e2e19eb4 from 'nuxt_plugin_vueyoutube_e2e19eb4' // Source: ../../../plugins/vue-youtube (mode: 'client')
import nuxt_plugin_uploadcare_7be56088 from 'nuxt_plugin_uploadcare_7be56088' // Source: ../../../plugins/uploadcare (mode: 'client')
import nuxt_plugin_analytics_0ae804d0 from 'nuxt_plugin_analytics_0ae804d0' // Source: ../../../plugins/analytics (mode: 'client')
import nuxt_plugin_datadog_3cd4b11c from 'nuxt_plugin_datadog_3cd4b11c' // Source: ../../../plugins/datadog (mode: 'client')
import nuxt_plugin_plugin_2855d7ca from 'nuxt_plugin_plugin_2855d7ca' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_fiiauth_32776352 from 'nuxt_plugin_fiiauth_32776352' // Source: ../../../plugins/fii-auth.js (mode: 'all')
import nuxt_plugin_disableconsolelog_05bd21e4 from 'nuxt_plugin_disableconsolelog_05bd21e4' // Source: ../../../plugins/disable-console-log.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../../../plugins/axios.js (mode: 'all')
import nuxt_plugin_socapescaper_4f232fa5 from 'nuxt_plugin_socapescaper_4f232fa5' // Source: ../../../plugins/socap_escaper.js (mode: 'all')
import nuxt_plugin_featureflag_765944fe from 'nuxt_plugin_featureflag_765944fe' // Source: ../../../plugins/feature-flag.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Home - UpTogether.org","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"UpTogether - Home"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@5.8.55\u002Fcss\u002Fmaterialdesignicons.min.css","rel":"preload","as":"style","onload":"this.rel='stylesheet'"}],"script":[{"src":"\u002Fupscope.js","defer":true},{"src":"https:\u002F\u002Fcdn.plaid.com\u002Flink\u002Fv2\u002Fstable\u002Flink-initialize.js","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_vue2editor_2de2f454 === 'function') {
    await nuxt_plugin_vue2editor_2de2f454(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_806daa4c === 'function') {
    await nuxt_plugin_apollomodule_806daa4c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_7801c226 === 'function') {
    await nuxt_plugin_pluginutils_7801c226(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_76b3a4f8 === 'function') {
    await nuxt_plugin_pluginrouting_76b3a4f8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_0d282977 === 'function') {
    await nuxt_plugin_pluginmain_0d282977(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_9921de94 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_9921de94(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_27654d0e === 'function') {
    await nuxt_plugin_axios_27654d0e(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_2d776742 === 'function') {
    await nuxt_plugin_buefy_2d776742(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_34921350 === 'function') {
    await nuxt_plugin_googleanalytics_34921350(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aws_5e4623c7 === 'function') {
    await nuxt_plugin_aws_5e4623c7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_i18ncompare_aa7992a8 === 'function') {
    await nuxt_plugin_i18ncompare_aa7992a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cleave_2450328d === 'function') {
    await nuxt_plugin_cleave_2450328d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2filters_577e82e7 === 'function') {
    await nuxt_plugin_vue2filters_577e82e7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecountryregionselect_5048da16 === 'function') {
    await nuxt_plugin_vuecountryregionselect_5048da16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_materialdesignicons_b188790a === 'function') {
    await nuxt_plugin_materialdesignicons_b188790a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_json5_346d62d2 === 'function') {
    await nuxt_plugin_json5_346d62d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_timeago_cf036a34 === 'function') {
    await nuxt_plugin_timeago_cf036a34(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidatei18n_1c3a79c8 === 'function') {
    await nuxt_plugin_veevalidatei18n_1c3a79c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mixins_5013a1f0 === 'function') {
    await nuxt_plugin_mixins_5013a1f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_i18ncookie_bb2b8886 === 'function') {
    await nuxt_plugin_i18ncookie_bb2b8886(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueyoutube_e2e19eb4 === 'function') {
    await nuxt_plugin_vueyoutube_e2e19eb4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_uploadcare_7be56088 === 'function') {
    await nuxt_plugin_uploadcare_7be56088(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_0ae804d0 === 'function') {
    await nuxt_plugin_analytics_0ae804d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadog_3cd4b11c === 'function') {
    await nuxt_plugin_datadog_3cd4b11c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2855d7ca === 'function') {
    await nuxt_plugin_plugin_2855d7ca(app.context, inject)
  }

  if (typeof nuxt_plugin_fiiauth_32776352 === 'function') {
    await nuxt_plugin_fiiauth_32776352(app.context, inject)
  }

  if (typeof nuxt_plugin_disableconsolelog_05bd21e4 === 'function') {
    await nuxt_plugin_disableconsolelog_05bd21e4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_socapescaper_4f232fa5 === 'function') {
    await nuxt_plugin_socapescaper_4f232fa5(app.context, inject)
  }

  if (typeof nuxt_plugin_featureflag_765944fe === 'function') {
    await nuxt_plugin_featureflag_765944fe(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
